import { Modal } from "ngx-modal";
import { OnInit, EventEmitter, SimpleChanges } from '@angular/core';
import { PrintSettings } from "../models/print-settings";
import { PdfService } from "../../shared/services/pdf.service";
import { AlertService } from "../../shared/services/alert.service";
import { Assignment } from "app/shared/models/Assignment";
var PrintDialogComponent = /** @class */ (function () {
    function PrintDialogComponent(pdfService, alertService) {
        this.pdfService = pdfService;
        this.alertService = alertService;
        this.close = new EventEmitter();
        this.printSettings = new PrintSettings();
        this._hasPrinted = false;
        this.hideNotesOption = false;
    }
    PrintDialogComponent.prototype.ngOnInit = function () {
    };
    PrintDialogComponent.prototype.ngOnChanges = function (changes) {
        if (this.isOpen && !this.modal.isOpened) {
            this.modal.open();
            this._hasPrinted = false;
        }
        else if (!this.isOpen && this.modal.isOpened) {
            this.modal.close();
        }
    };
    Object.defineProperty(PrintDialogComponent.prototype, "printingComplete", {
        get: function () {
            return !this.printing && this._hasPrinted;
        },
        enumerable: true,
        configurable: true
    });
    PrintDialogComponent.prototype.handlePrint = function () {
        var _this = this;
        this._hasPrinted = false;
        this.printing = true;
        var url = window.location.href;
        if (this.printSettings.showTherapistNotes) {
            url += "?notes=1";
        }
        // 2 minutes to time out for generating the report.
        var alert = this.alertService.info("Generating PDF Report", 120000);
        this.pdfService.generate(url, this.assignment)
            .then(function (fileId) {
            _this.filePrintId = fileId;
            _this.alertService.clearAlert(alert);
            _this.printing = false;
            _this._hasPrinted = true;
            _this.alertService.success("PDF report successfully generated");
        })
            .catch(function (error) {
            _this.printing = false;
            console.error(error);
            _this.alertService.clearAlert(alert);
            _this.alertService.error("PDF failed to generate.  Check your internet connection and try again.  Contact customer support if you keep experiencing problems");
        });
        // this.handleClose();
    };
    Object.defineProperty(PrintDialogComponent.prototype, "downloadFileUrl", {
        get: function () {
            if (!this.printingComplete) {
                return "";
            }
            return this.pdfService.getPDFUrl(this.filePrintId);
        },
        enumerable: true,
        configurable: true
    });
    PrintDialogComponent.prototype.updateTherapistNoteSettings = function (event) {
        var target = event.target;
        this.printSettings.showTherapistNotes = target.checked;
    };
    PrintDialogComponent.prototype.handleClose = function () {
        this.close.emit();
    };
    return PrintDialogComponent;
}());
export { PrintDialogComponent };



// WEBPACK FOOTER //
// ./src/app/reports/print-dialog/print-dialog.component.ts.pre-build-optimizer.js